import "../styles/application.css";

import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import React from "react";

const pages = import.meta.glob<{ default: React.ComponentType }>(
  "../pages/**/*.tsx",
  { eager: false }
);

createInertiaApp({
  resolve: async (name) => {
    const importer = pages[`../pages/${name}.tsx`];
    if (!importer) {
      throw new Error(
        `Página Inertia "${name}" não encontrada em app/frontend/pages/`
      );
    }
    const module = await importer();
    return module.default;
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />);
  },
  progress: {
    color: "var(--primary)",
    showSpinner: false,
  },
});
